// Added by Sejune Oh on 2020-04-06
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { FC } from 'react'
import {
    TablePagination as MaterialUITablePagination,
    TablePaginationProps as MaterialUITablePaginationProps
} from '@material-ui/core'

interface TablePaginationBaseProps { }
export type TablePaginationProps = TablePaginationBaseProps & MaterialUITablePaginationProps

export const TablePagination: FC<TablePaginationProps> = ({ ...props }) => {
    return <MaterialUITablePagination {...props}></MaterialUITablePagination>
}
